var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "showFraction" },
    [
      _c("content-header", [
        _c(
          "div",
          {
            staticClass: "header-left-box",
            attrs: { slot: "header-left" },
            slot: "header-left",
          },
          [
            _c(
              "div",
              { staticClass: "return-prev", on: { click: _vm.retuenPrev } },
              [
                _c("span", { staticClass: "icon-box" }, [
                  _c("span", { staticClass: "el-icon-arrow-left" }),
                ]),
                _c("span", { staticClass: "return-text" }, [
                  _vm._v(_vm._s(_vm.$t("showFraction.FH"))),
                ]),
              ]
            ),
            _c("content-header-title", [
              _c("span", [_vm._v(_vm._s(_vm.$t("showFraction.CKCJ")))]),
            ]),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "main" },
        [
          _c("team-statistics", { attrs: { stData: _vm.stData } }),
          _c(
            "div",
            { staticClass: "table-box" },
            [
              _c("c-table", {
                attrs: {
                  tableData: _vm.stData.itemList,
                  ISChangeCheckout: false,
                  tableHeader: _vm.teamTableHeader,
                  TableHeight: `calc( 100vh - ${324}px )`,
                },
                on: { operation: _vm.operation },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }